import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Eye, Paperclip } from "lucide-react";
import api, { fileUrl } from "@/lib/api";

export default function BlogPostPage() {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/blog/${id}`).then(({ data }) => setPost(data)).catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-8 mt-20 text-center" data-testid="post-not-found">
        <p className="font-heading text-2xl font-bold">Post not found</p>
        <Link to="/blog" className="text-blue-600 text-sm font-semibold mt-4 inline-block">← Back to blog</Link>
      </div>
    );
  }
  if (!post) return <div className="max-w-3xl mx-auto px-8 mt-12"><div className="h-96 rounded-2xl bg-slate-100 animate-pulse" /></div>;

  return (
    <article data-testid="blog-post-page" className="max-w-3xl mx-auto px-4 sm:px-8 mt-10">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-slate-400 hover:text-blue-600">
        <ArrowLeft className="w-3.5 h-3.5" /> All posts
      </Link>
      <div className="flex gap-1.5 flex-wrap mt-6">
        {(post.tags || []).map((t) => <span key={t} className="text-[10px] uppercase tracking-widest font-bold text-blue-600 bg-blue-50 px-2.5 py-1 rounded-full">{t}</span>)}
      </div>
      <h1 className="font-heading text-3xl sm:text-5xl font-bold tracking-tight mt-4 leading-tight">{post.title}</h1>
      <p className="text-sm text-slate-400 mt-4 flex items-center gap-4">
        <span>{post.author} · {new Date(post.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
        <span className="inline-flex items-center gap-1"><Eye className="w-3.5 h-3.5" /> {post.views} views</span>
      </p>
      {post.cover_image && (
        <img src={fileUrl(post.cover_image)} alt={post.title} className="w-full rounded-2xl mt-8 object-cover max-h-[420px]" />
      )}
      <div className="mt-10 text-base sm:text-lg text-slate-700 leading-relaxed whitespace-pre-wrap">{post.body}</div>
      {post.attachment_url && (
        <a data-testid="post-attachment-link" href={fileUrl(post.attachment_url)} target="_blank" rel="noreferrer"
          className="mt-10 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-semibold hover:border-blue-500 hover:text-blue-600 transition-colors">
          <Paperclip className="w-4 h-4" /> {post.attachment_name || "Download attachment"}
        </a>
      )}
    </article>
  );
}
